import * as React from 'react';

const SectionCenterFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-center-fill_svg__eds-icon--section-center_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-center-fill_svg__eds-icon--section-center-fill_base"
            fill="#010101"
            d="M8 20h8v-4H8v4z"
        />
        <path
            id="section-center-fill_svg__eds-icon--section-center-fill_middle"
            fill="#010101"
            d="M4 10h16v4H4z"
        />
        <path
            id="section-center-fill_svg__eds-icon--section-center-fill_top_1_"
            fill="#010101"
            d="M4 4h16v4H4z"
        />
    </svg>
);

SectionCenterFillSvg.displayName = 'SectionCenterFillSvg';
export default SectionCenterFillSvg;
